import { Link } from "react-router-dom";
import Reveal from "@/components/Reveal";

export default function AboutTeaser() {
  return (
    <section id="about-teaser" className="relative py-24 md:py-36" data-testid="about-teaser-section">
      <div className="max-w-7xl mx-auto px-6 grid lg:grid-cols-2 gap-16 lg:gap-24 items-center">
        <Reveal className="relative order-2 lg:order-1">
          <div className="relative border border-[rgba(169,129,47,0.26)] p-3 md:p-4" data-testid="about-image-frame">
            <span className="absolute -top-px -left-px w-5 h-5 border-t border-l border-gold" aria-hidden="true" />
            <span className="absolute -bottom-px -right-px w-5 h-5 border-b border-r border-gold" aria-hidden="true" />
            <div className="overflow-hidden">
              <img
                src="/images/medallion.webp"
                alt="A cast brass T.A.L.K. medallion on a warm plaster wall beside dried flowers"
                loading="lazy"
                className="w-full h-[340px] md:h-[480px] object-cover object-top hover:scale-[1.03] transition-transform duration-[1400ms] ease-out"
                data-testid="about-image"
              />
            </div>
          </div>
        </Reveal>

        <div className="order-1 lg:order-2">
          <Reveal>
            <p className="eyebrow mb-6">The Founder</p>
            <h2 className="font-display text-ink font-medium leading-[1.1] text-4xl sm:text-5xl" data-testid="about-teaser-heading">
              Rajdeep Brar
            </h2>
            <p className="mt-3 text-[11px] uppercase tracking-[0.24em] text-gold">
              Human Dynamics &amp; Transformation Strategist
            </p>
          </Reveal>
          <Reveal delay={0.1}>
            <div className="mt-7 space-y-5 text-inkdim leading-relaxed text-[15px] max-w-lg">
              <p>
                Seven-plus years building and leading across hospitality and lifestyle
                ventures — including the Alchemy &amp; Earth jewellery brand and large
                restaurant teams — taught Rajdeep one thing above all: every room runs
                on the patterns of the people in it.
              </p>
              <p>
                An NLP-certified practitioner with a reputation for uncannily accurate
                reads, she doesn't offer comfort-first sessions. She shows you the pattern —
                and once you can see it, it stops running you.
              </p>
            </div>
          </Reveal>
          <Reveal delay={0.18}>
            <blockquote
              className="mt-9 border-l border-gold pl-6 font-display italic text-goldink text-xl md:text-2xl leading-relaxed"
              data-testid="about-philosophy-quote"
            >
              "I don't tell people how to live. I help them see the patterns they couldn't see before."
            </blockquote>
            <Link
              to="/about"
              data-testid="about-read-more-link"
              className="gold-underline-link inline-block mt-9 text-[11px] uppercase tracking-[0.24em] text-gold"
            >
              Her full story
            </Link>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
